import { forEach, replace } from 'lodash/fp';
/*
 * This function replaces all wildcards starting with "%1", "%2"....
 * You can pass an array with the values that will be used to replace the wildcard in the order found in the list.
 */
export const replaceInText = (replacementList: string[] = [], stringText = '') => {
  let accumulator = stringText;
  let index = 1;

  forEach((replaceElement) => {
    const reg = new RegExp(`%${index}`, 'g');
    accumulator = replace(reg, replaceElement, accumulator);
    index += 1;
  }, replacementList);

  return accumulator;
};
